function readQQMapKey() {
  try {
    const systemInfo = JSON.parse(localStorage.getItem('java110SystemInfo') || '{}')
    return systemInfo.qqMapKey || ''
  } catch (e) {
    return ''
  }
}

export function loadQQMapScript() {
  const key = readQQMapKey()
  if (!key) {
    return Promise.reject(new Error('QQ地图Key未配置'))
  }

  const encodedKey = encodeURIComponent(key)
  const loadedScript = Array.from(document.scripts).find(script =>
    script.src.includes('map.qq.com/api/gljs') && script.src.includes(`key=${encodedKey}`)
  )

  if (window.TMap && loadedScript) {
    return Promise.resolve()
  }

  if (window.__qqMapLoadingPromise) {
    return window.__qqMapLoadingPromise
  }

  Array.from(document.scripts)
    .filter(script => script.src.includes('map.qq.com/api/gljs'))
    .forEach(script => script.parentNode && script.parentNode.removeChild(script))

  window.__qqMapLoadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${encodedKey}`
    script.onload = () => {
      window.__qqMapLoadingPromise = null
      resolve()
    }
    script.onerror = () => {
      window.__qqMapLoadingPromise = null
      reject(new Error('QQ地图脚本加载失败'))
    }
    document.head.appendChild(script)
  })

  return window.__qqMapLoadingPromise
}
